var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "userCenter warp" }, [
      _c("div", { staticClass: "leftMenu" }, [
        _c(
          "div",
          { staticClass: "leftMenuBox" },
          [
            _c(
              "el-menu",
              {
                attrs: {
                  "default-active": _vm.defaultActive,
                  "active-text-color": "#FF7800",
                  router: ""
                }
              },
              [
                _c("el-menu-item", { staticClass: "flex-start" }, [
                  _c("span", { staticClass: "title flag" }, [
                    _c("i", { staticClass: "icon-add19 flag" }),
                    _vm._v("我的交易")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "el-menu-item",
                  { staticClass: "flex-start", attrs: { index: "myOrder" } },
                  [
                    _c("span", { staticClass: "title child" }, [
                      _vm._v("我的订单")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-menu-item",
                  {
                    staticClass: "flex-start",
                    attrs: { index: "myOrder_serv" }
                  },
                  [
                    _c("span", { staticClass: "title child" }, [
                      _vm._v("我的服务订单")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-menu-item",
                  {
                    staticClass: "flex-start",
                    attrs: { index: "orderAfterSale" }
                  },
                  [
                    _c("span", { staticClass: "title child" }, [
                      _vm._v("售后订单")
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.schoolFlag
                  ? _c(
                      "el-menu-item",
                      {
                        staticClass: "flex-start",
                        attrs: { index: "receipt" }
                      },
                      [
                        _c("span", { staticClass: "title child" }, [
                          _vm._v("我的收货单")
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", {
                  staticStyle: {
                    "border-top": "1px dotted #E5E5E5",
                    "padding-top": "5px",
                    "margin-top": "20px",
                    width: "100%"
                  }
                }),
                _vm._v(" "),
                _c("el-menu-item", { staticClass: "flex-start" }, [
                  _c("span", { staticClass: "title flag" }, [
                    _c("i", { staticClass: "icon-add15 flag" }),
                    _vm._v("企业信息管理")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "el-menu-item",
                  { staticClass: "flex-start", attrs: { index: "userInfo" } },
                  [
                    _c("span", { staticClass: "title child" }, [
                      _vm._v("个人资料")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-menu-item",
                  {
                    staticClass: "flex-start",
                    attrs: { index: "companyCertificate" }
                  },
                  [
                    _c("span", { staticClass: "title child" }, [
                      _vm._v("企业认证")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-menu-item",
                  {
                    staticClass: "flex-start",
                    attrs: { index: "signingAddress" }
                  },
                  [
                    _c("span", { staticClass: "title child" }, [
                      _vm._v("收货地址管理")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", {
                  staticStyle: {
                    "border-top": "1px dotted #E5E5E5",
                    "padding-top": "5px",
                    "margin-top": "20px",
                    width: "100%"
                  }
                }),
                _vm._v(" "),
                _c("el-menu-item", { staticClass: "flex-start" }, [
                  _c("span", { staticClass: "title flag" }, [
                    _c("i", { staticClass: "icon-add110 flag" }),
                    _vm._v("我的资产")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "el-menu-item",
                  {
                    staticClass: "flex-start",
                    attrs: { index: "billPayServer" }
                  },
                  [
                    _c("span", { staticClass: "title child" }, [
                      _vm._v("账期支付服务")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-menu-item",
                  { staticClass: "flex-start", attrs: { index: "shopData" } },
                  [
                    _c("span", { staticClass: "title child" }, [
                      _vm._v("我的店铺")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", {
                  staticStyle: {
                    "border-top": "1px dotted #E5E5E5",
                    "padding-top": "5px",
                    "margin-top": "20px",
                    width: "100%"
                  }
                }),
                _vm._v(" "),
                _c("el-menu-item", { staticClass: "flex-start" }, [
                  _c("span", { staticClass: "title flag" }, [
                    _c("i", { staticClass: "icon-Personal-information flag" }),
                    _vm._v("用户中心")
                  ])
                ]),
                _vm._v(" "),
                _vm.platform == "b2c"
                  ? _c(
                      "el-menu-item",
                      {
                        staticClass: "flex-start",
                        attrs: { index: "currency" }
                      },
                      [
                        _c("span", { staticClass: "title child" }, [
                          _vm._v("我的咖币")
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-menu-item",
                  { staticClass: "flex-start", attrs: { index: "message" } },
                  [
                    _c("span", { staticClass: "title child" }, [
                      _vm._v("我的消息"),
                      _vm.userInfo.notRead
                        ? _c("span", { staticClass: "tip" }, [
                            _vm._v(_vm._s(_vm.userInfo.notRead))
                          ])
                        : _vm._e()
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-menu-item",
                  { staticClass: "flex-start", attrs: { index: "qaList" } },
                  [
                    _c("span", { staticClass: "title child" }, [
                      _vm._v("我的问答")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-menu-item",
                  { staticClass: "flex-start", attrs: { index: "myEvaluate" } },
                  [
                    _c("span", { staticClass: "title child" }, [
                      _vm._v("我的评价")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-menu-item",
                  {
                    staticClass: "flex-start",
                    attrs: { index: "couponPackage" }
                  },
                  [
                    _c("span", { staticClass: "title child" }, [
                      _vm._v("劵 包")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-menu-item",
                  {
                    staticClass: "flex-start",
                    attrs: { index: "browseRecords" }
                  },
                  [
                    _c("span", { staticClass: "title child" }, [
                      _vm._v("浏览足迹")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", {
                  staticStyle: {
                    "border-top": "1px dotted #E5E5E5",
                    "padding-top": "5px",
                    "margin-top": "20px",
                    width: "100%"
                  }
                }),
                _vm._v(" "),
                _c("el-menu-item", { staticClass: "flex-start" }, [
                  _c("span", { staticClass: "title flag" }, [
                    _c("i", { staticClass: "icon-shoucang flag" }),
                    _vm._v("我的收藏")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "el-menu-item",
                  { staticClass: "flex-start", attrs: { index: "favorites" } },
                  [
                    _c("span", { staticClass: "title child" }, [
                      _vm._v("我的收藏")
                    ])
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "userCenterInfo" }, [_c("router-view")], 1)
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-7364ec45", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-7364ec45","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/userCenter/userCenter.vue
// module id = null
// module chunks = 